<template>
  <v-snackbar
    v-model="showPrompt"
    location="top center"
    timeout="-1"
    class="update-snackbar notranslate"
    content-class="update-snackbar-content notranslate"
    translate="no"
  >
    <div class="d-flex align-center ga-3 notranslate" translate="no">
      <v-icon color="#f59e0b" size="22">mdi-translate-off</v-icon>
      <span class="update-text">{{
        $t('Automatic translation may affect understanding')
      }}</span>
    </div>

    <template #actions>
      <v-btn
        icon
        variant="text"
        size="x-small"
        class="update-btn-close"
        @click="dismiss"
      >
        <v-icon size="18">mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'

const DISMISS_KEY = 'translateWarningDismissed'
const showPrompt = ref(false)
let observer: MutationObserver | null = null
let dismissed = false

const isGoogleTranslated = () => {
  const html = document.documentElement
  const htmlClass = html.className || ''

  if (
    html.classList.contains('translated-ltr') ||
    html.classList.contains('translated-rtl') ||
    htmlClass.includes('translated-')
  ) {
    return true
  }

  return Boolean(
    document.querySelector(
      'iframe.skiptranslate, .skiptranslate, .goog-te-banner-frame, #goog-gt-tt, html.translated-ltr, html.translated-rtl, link[href*="translate.googleapis.com"]'
    )
  )
}

const syncWarning = () => {
  if (dismissed) {
    showPrompt.value = false
    return
  }

  showPrompt.value = isGoogleTranslated()
}

const dismiss = () => {
  dismissed = true
  sessionStorage.setItem(DISMISS_KEY, '1')
  showPrompt.value = false
}

onMounted(() => {
  dismissed = sessionStorage.getItem(DISMISS_KEY) === '1'
  syncWarning()

  observer = new MutationObserver(syncWarning)
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true,
    subtree: false,
  })
  observer.observe(document.head, { childList: true, subtree: true })
  observer.observe(document.body, { childList: true, subtree: false })
})

onUnmounted(() => {
  observer?.disconnect()
  observer = null
})
</script>

<style scoped lang="scss">
.update-snackbar {
  :deep(.v-snackbar__wrapper) {
    border-radius: 14px;
    border: 2px solid transparent;
    background:
      linear-gradient(#fff 0 0) padding-box,
      var(--linearHotPinkDodgerBlue) border-box;
    box-shadow:
      0 4px 16px rgba(74, 114, 255, 0.12),
      0 2px 6px rgba(0, 0, 0, 0.05);
    min-width: auto;
    overflow: visible;
  }

  :deep(.v-snackbar__content) {
    padding: 12px 8px 12px 20px;
  }

  :deep(.v-snackbar__actions) {
    margin-inline-end: 8px;
    gap: 4px;
  }
}

.update-text {
  font-family: Fredoka, sans-serif;
  font-weight: 500;
  font-size: 0.9rem;
  color: #1f2d37;
}

.update-btn-close {
  color: #8a9199 !important;
  opacity: 0.7;

  &:hover {
    opacity: 1;
  }
}
</style>
